import { render } from "./MainInfo.vue?vue&type=template&id=433b8133&scoped=true"
import script from "./MainInfo.vue?vue&type=script&lang=js"
export * from "./MainInfo.vue?vue&type=script&lang=js"

import "./MainInfo.vue?vue&type=style&index=0&id=433b8133&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433b8133"]])

export default __exports__